import React from 'react';

export default function PanelHeader({ title, icon }) {
  return (
    <div className="pixie-panel-header">
      {icon && <i className={`fa-solid ${icon}`} aria-hidden />}
      <span>{title}</span>
    </div>
  );
}
